import { useLocalTranslation } from '@/hooks/useLocalTranslation';

import DisplayName from "@/pages/profile/sections/basicDetails/sections/displayName"
import UserName from "@/pages/profile/sections/basicDetails/sections/userName"
import Email from "@/pages/profile/sections/basicDetails/sections/email"
import OtpVerification from "@/pages/profile/sections/basicDetails/sections/otpVerification"
import Dob from "@/pages/profile/sections/basicDetails/sections/dob"
import WhatsAppNo from "@/pages/profile/sections/basicDetails/sections/whatsAppNo"
import Gender from "@/pages/profile/sections/basicDetails/sections/gender"

import "./style.css"

export default function BasicDetailsView(props: any) {
    const { profile } = useLocalTranslation();

    const componentMap: any = [
        <DisplayName
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.displayName}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <UserName
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.username}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <Email
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.email}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <OtpVerification
            email={props.email}
            handleSubmit={props.handleSubmit}
        />,
        <Dob
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.dob}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <WhatsAppNo
            errMsg={props.errMsg}
            handleOnCheckBoxChanged={props.handleOnCheckBoxChanged}
            checked={props.isWhatsAppNoSameAsContactNo}
            id="whatsAppNo"
            text={profile.basicDetailsSection.whatsAppNoNote}

            whatsAppCountryCode={props.whatsAppCountryCode}

            whatsAppNumber={props.whatsAppNumber}
            whatsAppNumberPlaceholder={profile.placeHolders.whatsAppNumber}

            handleInputChange={props.handleInputChange}
            handleSubmit={props.handleSubmit}
            isSubmitBtnLoading={props.isSubmitBtnLoading}

        />,
        <Gender
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.gender}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />
    ];
    const ComponentToRender = componentMap[props.profileStepNo];

    return (
        <div
            className={`basicDetailsView
        rounded-[10px] profileSectionCommonMainCon`}>
            <h1 className='commonH1'>{profile.basicDetailsSection.heading}</h1>
            {ComponentToRender || null}
        </div>
    );
}
